import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

interface AuraScan {
  id: string;
  timestamp: string;
  purity: number;
  dominantColor: string;
  energy: number;
  status: 'pure' | 'balanced' | 'needs_cleansing';
}

export function AuraScanHistory() {
  const scans: AuraScan[] = [
    {
      id: '1',
      timestamp: '2024-01-15 14:30',
      purity: 95,
      dominantColor: 'Golden',
      energy: 88,
      status: 'pure'
    },
    {
      id: '2',
      timestamp: '2024-01-14 09:15',
      purity: 82,
      dominantColor: 'Blue',
      energy: 76,
      status: 'balanced'
    },
    {
      id: '3',
      timestamp: '2024-01-13 16:45',
      purity: 68,
      dominantColor: 'Green',
      energy: 65,
      status: 'needs_cleansing'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'pure': return 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30';
      case 'balanced': return 'bg-blue-500/20 text-blue-300 border-blue-500/30';
      default: return 'bg-orange-500/20 text-orange-300 border-orange-500/30';
    }
  };

  return (
    <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-purple-500/30">
      <CardHeader>
        <CardTitle className="text-purple-200">Aura Scan History</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {scans.map((scan) => (
            <div key={scan.id} className="flex items-center justify-between p-3 rounded-lg bg-purple-900/10 border border-purple-500/20">
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                  <span className="text-sm text-purple-300">{scan.timestamp}</span>
                  <Badge className={getStatusColor(scan.status)}>
                    {scan.status.replace('_', ' ')}
                  </Badge>
                </div>
                <div className="text-xs text-purple-400">
                  Purity: {scan.purity}% • Energy: {scan.energy}% • Color: {scan.dominantColor}
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}